<div class="body">
    <br/>
    <div class="row">

        <div class="col-lg-5"> </div>

        <div class="center">
            <h1> Desafiliación </h1>
        </div>

        <div class="col-lg-4"> </div>

    </div>

    <div class="container principal">

        <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

            <div class="row">

                <div class="col-lg-4"> </div>

                <div class="col-lg-8">
                    <p> <b> Usuario: </b> nombre de prueba </p>
                </div>

            </div>

        </div>



        <div *ngIf="rol != 'ROLE_AFILIADO'" style="padding-bottom: 20px;">

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2">
                    <h2> Rut Afiliado </h2>
                </div>

                <div class="col-lg-6">

                    <input id="txt_rut" name="afiliado" class="form-control" type="text" required placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1">

                    <button class="btn btn-primary" id="btnvalida">
    
                            Buscar
    
                        </button>

                </div>

                <div class="col-lg-1"> </div>

            </div>
        </div>
        <br/>
        <div class="row">

            <div class="col-lg-8"> </div>

            <div class="col-lg-4">
                <p> <b> Usuario: </b> nombre de prueba</p>
            </div>

        </div>
        <br/>
        <div class="table-responsive">

            <table class="table">

                <thead style="background-color: #0f69b4;color:white;">

                    <tr>
                        <th scope="col"> Rut Afiliado</th>

                        <th scope="col"> Nombre Afiliado </th>

                        <th scope="col"> Fecha Afiliación </th>
                        <th scope="col"> Fecha Desafiliación </th>
                        <th scope="col"> Actualizar </th>
                        <th scope="col"> Motivo Desafiliación</th>



                    </tr>

                </thead>

                <tbody>

                    <tr [class]="'rowEven' ">
                        <td>xx.xxx.xxx-x</td>
                        <td>Nombre prueba</td>
                        <td>15/08/2021</td>
                        <td></td>
                        <td><select id="estadoAfiliado" name="estadoAfiliado" class="form-control" required>
                                <option value="0">Desafiliar</option>
                                <option value="1">Suspender </option>
                                <option value="2">Suspención Definitiva</option>
                                </select>
                        </td>
                        <td>
                            <input name="txtMotivo" id="txtMotivo">
                        </td>

                    </tr>
                    <tr [class]="'rowOdd' ">
                        <td>xx.xxx.xxx-x</td>
                        <td>Nombre prueba</td>
                        <td>10/05/2020</td>
                        <td></td>
                        <td><select id="estadoAfiliado" name="estadoAfiliado" class="form-control" required>
                                <option value="0">Desafiliar</option>
                                <option value="1">Suspender </option>
                                <option value="2">Suspención Definitiva</option>
                                </select>
                        </td>
                        <td>
                            <input name="txtMotivo" id="txtMotivo"></td>
                    </tr>

                </tbody>

            </table>

        </div>
        <br/>


        <br/>

        <div class="row line">

            <div class="col-lg-5"> </div>

            <div class="col-lg-6">
                <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'">
                    <button class="btn btn-success">

                        Actualizar

                    </button>
                </div>
            </div>

            <div class="col-lg-1 col-sm-1"> </div>

        </div>



    </div>

    <div class="container" style="height:100px"> </div>

</div>